import axios from "axios";
import { serverUrl } from "../_constants";
import { history } from "./history";

// Хосты, где "/" — вход в кабинет организатора, а не привязанный к конференции
// домен. Всё, что не в списке, считается возможным доменом мероприятия.
const CABINET_HOSTS = ["demo.naviconf.com", "lk.naviconf.com", "localhost"];

// Вызывается из index.js до первого рендера: анонимный посетитель привязанного
// домена должен попасть сразу на /event/{id}. Делать проверку внутри кабинета
// нельзя — PrivateRoute на "/" перебрасывает на /login раньше, чем смонтируется
// хоть один компонент с этой логикой (фича «привязка домена» так и не работала
// для анонимов с 2024-12-15, когда редирект положили в ConfListPage).
// history.replace, а не push: в истории не должно оставаться «/», по которому
// «назад» возвращает на сработавший PrivateRoute.
export function resolveBoundDomain() {
  if (process.env.REACT_APP_CHINA_MODE === "true") return Promise.resolve();
  if (window.location.pathname !== "/") return Promise.resolve();

  const host = window.location.hostname;
  if (CABINET_HOSTS.includes(host)) return Promise.resolve();

  // Рендер не должен зависнуть, пока бэк недоступен: axios по умолчанию ждёт
  // 30 секунд (user.service), поэтому сверху своя страховка на 3 секунды —
  // не ответило, показываем кабинет как есть.
  return Promise.race([
    axios.get(serverUrl + "api/conference-domain?domain=" + host, { timeout: 3000 }),
    new Promise((resolve) => setTimeout(resolve, 3000)),
  ])
    .then((res) => {
      const confId = res && res.data && res.data.conference_id;
      if (confId > 0) history.replace("/event/" + confId);
    })
    .catch(() => {});
}
